module.exports = __webpack_public_path__ + "img/bj_zanwushujv@2x.210608bc.png";